import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { meta } from '../../../meta';

export const Category = ({ text, size, active, onClick, colors }) => {
  const handleKeyPress = (e) => {
    if (e.key !== 'Enter') {
      return;
    }

    onClick(e);
  };

  return (
    <Container
      onClick={onClick}
      onKeyDown={handleKeyPress}
      role="button"
      tabIndex="0"
      $colors={colors}
      $size={size}
      $isActive={active}
    >
      {text}
    </Container>
  );
};

const Container = styled.div.attrs(({ $size, $isActive }) => ({
  className: classNames(
    `${meta.stylePrefix}-category-component`,
    `${meta.stylePrefix}-category-list-item`,
    `${meta.stylePrefix}-category-${$size}`,
    {
      [`${meta.stylePrefix}-category-active`]: $isActive
    }
  )
}))`
  display: inline-block;
  border: 1px solid transparent;
  border-radius: 2px;
  text-align: center;
  white-space: nowrap;
  transition-duration: 0.1s;
  transition-timing-function: ease;
  transition-property: background-color, color;
  cursor: pointer;

  &:hover,
  &:focus {
    color: ${({ $colors }) => $colors.filtersText};
  }

  ${({ $size }) => {
    if ($size === 'xsmall') {
      return css`
        padding: 5px 11px;
        font-size: 13px;
        line-height: 1.33;
      `;
    }

    if ($size === 'xmedium') {
      return css`
        padding: 6px 19px;
        font-size: 14px;
        line-height: 18px;
      `;
    }
  }}

  ${({ $isActive, $colors }) =>
    $isActive
      ? css`
          background-color: ${$colors.activeBackground};
          color: ${$colors.filtersText};
        `
      : css`
          border-color: ${$colors.inactiveBorder};
          color: ${$colors.inactiveText};
        `}
`;
